import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ISaleDashboardStats,
  ISaleMonthlyStats,
  ISaleDailyStats,
  SaleDashboardState,
} from "../../../types/dashboard/saleDashboardInterfaces";

/**
 * 🎯 Estado inicial para las estadísticas del dashboard de ventas
 */
const initialState: SaleDashboardState = {
  stats: {
    totalSales: 0,
    salesByStatus: {},
    salesByDocumentType: {},
    salesByBranch: {},
    salesByUser: {},
    salesByMonth: {},
  },
  monthlyStats: {
    year: new Date().getFullYear(),
    labels: [],
    values: [],
  },
  dailyStats: {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    labels: [],
    values: [],
  },
};

export const saleDashboardSlice = createSlice({
  name: "saleDashboard",
  initialState,
  reducers: {
    /**
     * ✅ Carga las estadísticas generales del dashboard de ventas.
     */
    setSaleStats: (state, action: PayloadAction<ISaleDashboardStats>) => {
      state.stats = action.payload;
    },

    /**
     * 📅 Carga las estadísticas de ventas mensuales (por año).
     */
    setMonthlySales: (state, action: PayloadAction<ISaleMonthlyStats>) => {
      state.monthlyStats = action.payload;
    },

    /**
     * 📆 Carga las estadísticas de ventas diarias (por mes y año).
     */
    setDailySales: (state, action: PayloadAction<ISaleDailyStats>) => {
      state.dailyStats = action.payload;
    },

    /**
     * 🔄 Limpia el estado del dashboard.
     */
    clearSaleDashboard: (state) => {
      state.stats = {
        totalSales: 0,
        salesByStatus: {},
        salesByDocumentType: {},
        salesByBranch: {},
        salesByUser: {},
        salesByMonth: {},
      };
      state.monthlyStats = {
        year: new Date().getFullYear(),
        labels: [],
        values: [],
      };
      state.dailyStats = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        labels: [],
        values: [],
      };
    },
  },
});

export const { setSaleStats, setMonthlySales, setDailySales, clearSaleDashboard } =
  saleDashboardSlice.actions;

export default saleDashboardSlice.reducer;
